import { api } from "@/utils/api";
import { updateUser } from "@/features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState, type FormEvent } from "react";
import { ProfileImageUpdater } from "./ProfileImageUpdater";

export function UpdateProfileForm() {
  const { user } = useSelector((state: { user }) => state.user);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    // Get the Form and create the FormData
    const htmlForm = e.target as HTMLFormElement;
    const formData = new FormData(htmlForm);

    // Sets the avatarImg and delete it from the FormData to prevent errors
    const avatarImg = formData.get("file") as File;
    formData.delete("file");

    // Update the user information (without profile image)
    const userData = Object.fromEntries(formData);
    await api.updateProfile(userData);

    // If a new profile image was provided, update it
    if (avatarImg.size) {
      const avatarForm = new FormData();
      avatarForm.set("file", avatarImg);

      const updatedUser = await api.updateAvatarPhoto(avatarForm);
      dispatch(updateUser(updatedUser));
    }

    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="default-form">
      <ProfileImageUpdater />
      <div className="row">
        {/* <!-- Input --> */}
        <div className="form-group col-lg-6 col-md-12">
          <label>Nombre</label>
          <input
            type="text"
            name="first_name"
            placeholder="Ingrese su nombre"
            defaultValue={user.first_name}
            required
          />
        </div>

        {/* <!-- Input --> */}
        <div className="form-group col-lg-6 col-md-12">
          <label>Apellido</label>
          <input
            type="text"
            name="last_name"
            placeholder="Ingrese su apellido"
            defaultValue={user.last_name}
            required
          />
        </div>

        {/* <!-- Input --> */}
        <div className="form-group col-12">
          <label>Teléfono</label>
          <input
            type="text"
            name="phone"
            placeholder="Ingrese su número de teléfono"
            defaultValue={user.phone}
            required
          />
        </div>

        {/* <!-- Input --> */}
        <div className="form-group col-12">
          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="Ingrese su email"
            defaultValue={user.email}
            required
          />
        </div>

        {/* <!-- Input --> */}
        <div className="form-group col-lg-12 col-md-12 text-end">
          <button
            type="submit"
            className="theme-btn btn-style-one"
            disabled={isLoading}
          >
            {isLoading ? (
              <div
                className="spinner-border"
                style={{ height: "15px", width: "15px" }}
                role="status"
              ></div>
            ) : (
              "Guardar"
            )}
          </button>
        </div>
      </div>
    </form>
  );
}
